import { handleActions, handleAction } from "redux-actions";
import {
  AUTH,
  SET_PROFILE,
  SET_CURRENT_ROUTE,
  LOGOUT,
  SHOW_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_SIDE_MENU_STATE,
  OPEN_ALERT_FORM,
  CLOSE_ALERT_FORM,
  EDIT_SELECTED_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  SET_ALERT_LIST,
  ADD_NEW_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  THEME,
  OPEN_INCIDENT_FORM,
  CLOSE_INCIDENT_FORM,
  EDIT_SELECTED_INCIDENT,
  INCIDENT_FORM_TOOGLE_LOADING,
} from "./../../constants";
import { createCrudReducers } from "../../utils/crudGenerator";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) => action.payload,
  {}
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  false
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

const userReducers = createCrudReducers('USER');

export const users = userReducers.list;
export const usersForm = userReducers.form;

const equipmentReducers = createCrudReducers('EQUIPMENT');

export const equipments = equipmentReducers.list;
export const equipmentsForm = equipmentReducers.form;
const locationReducers = createCrudReducers('LOCATION');

export const locations = locationReducers.list;
export const locationsForm = locationReducers.form;
const roleReducers = createCrudReducers('ROLE');
export const roles = roleReducers.list;
export const rolesForm = roleReducers.form;
const incidentReducers = createCrudReducers('INCIDENT');

// Reducer personalizado para el formulario de incidentes que permite datos iniciales
export const incidentsForm = handleActions(
  {
    [OPEN_INCIDENT_FORM]: (state, action) => ({
      show: true,
      data: action.payload || null, // Permite datos iniciales desde el payload
      loading: false,
    }),
    [CLOSE_INCIDENT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_INCIDENT]: (state, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [INCIDENT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

export const incidents = incidentReducers.list;
const workorderReducers = createCrudReducers('WORKORDER');

export const workorders = workorderReducers.list;
export const workordersForm = workorderReducers.form;
const shifttypeReducers = createCrudReducers('SHIFTTYPE');

export const shifttypes = shifttypeReducers.list;
export const shifttypesForm = shifttypeReducers.form;
const appointmentReducers = createCrudReducers('APPOINTMENT');

export const appointments = appointmentReducers.list;
export const appointmentsForm = appointmentReducers.form;

// Reducer específico para el modal de creación bulk de turnos
export const bulkAppointmentsForm = (state = { show: false, data: null, loading: false }, action) => {
  switch (action.type) {
    case 'OPEN_BULK_APPOINTMENT_FORM':
      return { ...state, show: true, data: action.payload };
    case 'CLOSE_BULK_APPOINTMENT_FORM':
      return { ...state, show: false, data: null };
    case 'SET_BULK_APPOINTMENT_DATA':
      return { ...state, data: action.payload };
    case 'APPOINTMENT_FORM_TOOGLE_LOADING':
      return { ...state, loading: !state.loading };
    default:
      return state;
  }
};

// Reducer para el schedule mensual
export const monthlySchedule = (state = null, action) => {
  switch (action.type) {
    case 'SET_MONTHLY_SCHEDULE':
      return action.payload;
    case 'CLEAR_MONTHLY_SCHEDULE':
      return null;
    default:
      return state;
  }
};

// Reducer para los parámetros actuales del schedule (groupId, month, year)
export const currentScheduleParams = (state = null, action) => {
  switch (action.type) {
    case 'SET_CURRENT_SCHEDULE_PARAMS':
      return action.payload;
    default:
      return state;
  }
};

// Reducer para el filtro de usuarios en el calendario
export const userFilter = (state = '', action) => {
  switch (action.type) {
    case 'SET_USER_FILTER':
      return action.payload;
    case 'CLEAR_USER_FILTER':
      return '';
    default:
      return state;
  }
};

const groupReducers = createCrudReducers('GROUP');

export const groups = groupReducers.list;
export const groupsForm = groupReducers.form;
const permissionReducers = createCrudReducers('PERMISSION');

export const permissions = permissionReducers.list;
export const permissionsForm = permissionReducers.form;
const holidayReducers = createCrudReducers('HOLIDAY');

export const holidays = holidayReducers.list;
export const holidaysForm = holidayReducers.form;
const attendancerecordReducers = createCrudReducers('ATTENDANCERECORD');

export const attendancerecords = attendancerecordReducers.list;
export const attendancerecordsForm = attendancerecordReducers.form;
const timechangerequestReducers = createCrudReducers('TIMECHANGEREQUEST');

export const timechangerequests = timechangerequestReducers.list;
export const timechangerequestsForm = timechangerequestReducers.form;
const irregularitytypeReducers = createCrudReducers('IRREGULARITYTYPE');

export const irregularitytypes = irregularitytypeReducers.list;
export const irregularitytypesForm = irregularitytypeReducers.form;
const irregularityReducers = createCrudReducers('IRREGULARITY');

export const irregularitys = irregularityReducers.list;
export const irregularitysForm = irregularityReducers.form;
const maintenanceReducers = createCrudReducers('MAINTENANCE');

export const maintenances = maintenanceReducers.list;
export const maintenancesForm = maintenanceReducers.form;
